import { useState } from "react";
import { Card } from "./ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { Button } from "./ui/button";
import { Headphones, Book, Pencil, Mic, ChevronRight, LayoutGrid } from "lucide-react";

const SKILLS = [
  { id: "All", icon: LayoutGrid },
  { id: "Listening", icon: Headphones },
  { id: "Reading", icon: Book },
  { id: "Writing", icon: Pencil },
  { id: "Speaking", icon: Mic },
];

const LEVEL_STYLES = {
  B1: { gradient: "bg-gradient-to-br from-purple-500 to-purple-600", text: "text-purple-600" },
  B2: { gradient: "bg-gradient-to-br from-orange-500 to-orange-600", text: "text-orange-500" },
  C1: { gradient: "bg-gradient-to-br from-pink-500 to-pink-600", text: "text-pink-500" },
};

export const getTestId = () => {
  const id = window.location.pathname.split("/")[3];
  return id;
};

export function CompletedTestsPage({ AlltestsData, NewselectedLevel, onSectionChange }) {
  const [selectedSkill, setSelectedSkill] = useState("All");



  const getFilteredTests = (AlltestsData, skill_id, NewselectedLevel) => {
    if (!AlltestsData || !AlltestsData[NewselectedLevel]) {
      return [];
    }
  
    const levelTests = AlltestsData[NewselectedLevel] || [];
    const levelTestsArray = levelTests["tests"] || [];
  
    return levelTestsArray.filter(
      test => test.test_type === skill_id && test.status === "Task completed"
    );
  };
  

  const getAllTests = () => {
    const levelTests = AlltestsData[NewselectedLevel] || [];
    const levelTestsArray = levelTests["tests"] || [];

    if (selectedSkill === "All") {
      return levelTestsArray.filter(
        test =>
          ["Listening", "Reading", "Writing", "Speaking"].includes(test.test_type) &&
          test.status === "Task completed"
      );
    }
  };

  const filteredTests = selectedSkill === "All" ? getAllTests() : getFilteredTests(AlltestsData, selectedSkill, NewselectedLevel);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <Tabs value={selectedSkill} onValueChange={(value) => setSelectedSkill(value)}>
            <TabsList className="grid w-full grid-cols-5 gap-4 bg-transparent p-0 mb-6">
              {SKILLS.map((skill) => (
                <TabsTrigger
                  key={skill.id}
                  value={skill.id}
                  className={`flex items-center justify-center gap-2 p-3 rounded-lg transition-all duration-200 ${
                    selectedSkill === skill.id
                      ? `bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-md`
                      : "bg-white text-gray-600 hover:bg-gray-100"
                  }`}
                >
                  <skill.icon className="w-5 h-5" />
                  {skill.id}
                </TabsTrigger>
              ))}
            </TabsList>
            {SKILLS.map((skill) => (
              <TabsContent key={skill.id} value={skill.id}>
                {filteredTests.length > 0 ? (
                  <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                    {filteredTests.map((test) => {
                      const levelStyle = LEVEL_STYLES[NewselectedLevel];
                      return (
                        <Card key={test.id} className="overflow-hidden transition-all duration-300 hover:shadow-lg">
                          <div className={`${levelStyle ? levelStyle.gradient : ''} p-6 text-white`}>
                            <h3 className="text-2xl font-bold">{test.test_title}</h3>
                            <p className="text-sm opacity-90 mt-1">Completed on {test.assignment_completed_at}</p>
                          </div>
                          <div className="p-6 space-y-4">
                            <div className="flex justify-between items-center">
                              <div className="text-2xl font-bold">Score: {test.progress_score}%</div>
                              <Button
                                className="border-0 mt-auto"
                                variant="outline"
                                onClick={() => {
                                  window.location.href = `/elab/test-performance/${test.assignment_id}/`;
                                }}
                              >
                                Review
                                <ChevronRight className="ml-2 h-4 w-4" />
                              </Button>
                            </div>
                            <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                              <div className={`h-full ${levelStyle ? levelStyle.gradient : ''}`} style={{ width: `${test.progress_score}%` }} />
                            </div>
                          </div>
                        </Card>
                      );
                    })}
                  </div>
                ) : (
                  <Card>
                    <div className="text-center py-12">
                      <p className="text-gray-500 text-lg">No completed {skill.id.toLowerCase()} tests found.</p>
                      <Button className="mt-4 bg-blue-600 hover:bg-blue-700 text-white" onClick={() => onSectionChange("tests")}>
                        Take a New Test
                      </Button>
                    </div>
                  </Card>
                )}
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </div>
    </div>
  );
}